"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voiceToTextRequest = voiceToTextRequest;
async function voiceToTextRequest(userId, language, audio) {
    const response = await fetch(`/dashboard/${userId}/voicetotext/${language}`, {
        method: 'POST',
        headers: {
            'Content-Type': audio.type || 'application/octet-stream',
        },
        body: audio,
    });
    if (!response.ok) {
        throw new Error(`Voice-to-text request failed with status ${response.status}`);
    }
    const result = await response.json();
    if (!result.success || typeof result.text !== 'string') {
        throw new Error('Voice-to-text response did not contain text');
    }
    return result.text;
}
